<template>
	<div class="modal fade" ref="modal">
		<div class="modal-dialog">
			<div class="modal-content">
				<ul class="nav nav-pills">
					<li :class="{ active: 'access-info' == active }">
						<a @click="active = 'access-info'">Dados de acesso</a>
					</li>

					<li
						v-if="data.type == 'ENFGESTOR'"
						:class="{ active: 'comum-info' == active }"
					>
						<a @click="active = 'comum-info'">Informações comuns</a>
					</li>
					<li
						v-if="data.type == 'ENFGESTOR'"
						:class="{ active: 'metadata' == active }"
					>
						<a @click="active = 'metadata'">Metadata</a>
					</li>

					<li
						v-if="data.type == 'sst-viamed'"
						:class="{ active: 'sst-info' == active }"
					>
						<a @click="active = 'sst-info'">Informações do App</a>
					</li>
				</ul>
				<component :is="active" :dataIn="data" />
				<div class="modal-footer">
					<a-btn
						action="private-save-users"
						text="Salvar"
						icon="save"
						type="primary"
						@click="save"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import aBtn from 'btn';
	import accessInfo from './accessInfo.vue';
	import comumInfo from './comumInfo.vue';
	import sstInfo from './sstInfo.vue';
	import metadata from './metadata.vue';

	import WBS from 'js/http';
	import reset from './reset.js';
	import { clone } from 'lodash';
	import toastr from 'toastr';

	export default {
		name: 'UserModal',
		props: ['page'],
		inject: ['assets'],
		components: {
			aBtn,
			accessInfo,
			comumInfo,
			sstInfo,
			metadata,
		},
		data() {
			return {
				data: clone(reset),
				active: 'access-info',
			};
		},
		methods: {
			get_perfil(t) {
				let perfil = this.assets.perfis.find((item) => item.cod == t);
				return perfil == 0 ? 404 : perfil.desc;
			},
			open(data = null) {
				this.active = 'access-info';
				this.data = clone(data == null ? reset : data);
				$(this.$refs.modal).modal('show');
			},
			save() {
				if (this.data.pass == 'altpass') {
					toastr.error('As senhas são diferentes...');
					return;
				}

				if (this.data.pass == '') delete this.data.pass;

				WBS.send('private-save-users', this.data, (resp) => {
					// console.log(resp)
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$(this.$refs.modal).modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/settings/users/modal/index.vue